import React from 'react'

import type {
  TypeAlignmentFields,
  TypeHorizontalAlignment,
  TypeVerticalAlignment,
} from '@contentful-types/alignment'

interface AlignmentContextValue {
  horizontal: TypeHorizontalAlignment
  vertical: TypeVerticalAlignment
}

export const DefaultAlignment: TypeAlignmentFields = {
  horizontal: 'default',
  vertical: 'default',
}

export const AlignmentContext = React.createContext<AlignmentContextValue>(DefaultAlignment)
